import { browserDigest256, browserRandomBytes } from './browser.js';
import { nodeDigest256, nodeRandomBytes } from './node.js';
import { isBrowser } from '../environment.js';

// `require()` is suitable for cross-platform implementations

let crypto;

if (isBrowser) {
  const browserCrypto = self.crypto || self.msCrypto;

  if (!browserCrypto) {
    throw new Error('There was a problem initializing crypto for the browser');
  }

  crypto = {
    digest256: str => browserDigest256(browserCrypto, str),
    randomBytes: size => browserRandomBytes(browserCrypto, size)
  };
} else {
  const nodeCrypto = require('crypto');

  if (!nodeCrypto) {
    throw new Error('There was a problem initializing crypto for node');
  }

  crypto = {
    digest256: str => nodeDigest256(nodeCrypto, str),
    randomBytes: size => nodeRandomBytes(nodeCrypto, size)
  };
}

export { crypto };
